import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorCircle } from '@ori-ui/icons';
import { Tooltip, styled } from '@ori-ui/mui';
import { isNullOrUndefinedOrEmpty } from '../utils';
var ErrorCircleIcon = styled(ErrorCircle)(function() {
    return {
        fontSize: '24px'
    };
});
export var Icon = function(props) {
    var text = props.text;
    if (isNullOrUndefinedOrEmpty(text)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: text,
        children: /*#__PURE__*/ _jsx(ErrorCircleIcon, {
            color: "error"
        })
    });
};
